import { Dialog } from "construct-ui";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { FILE_EXTENSIONS } from "../../../config/constants";
import ViewBase from "../../view-base.view";
import { channelGoodsQtyCheck, getGoodsChannelTemplate } from "../../../models/posm/posm-goods-issue-application.model";
import PosmModel from "../../../models/posm/posm.model";

const UPLOADED_DATA = [{
  goodsControlId: 'Test goodsControlId',
  goodsName: 'Test goodsName',
  channelCode: 'Test channelCode',
  channelName: 'Test channelName',
  uploadQty: 'Test uploadQty',
  stockQty: 'Test stockQty',
  storageQty: 'Test storageQty',
  channelStockQty: 'Test channelStockQty',
  remarks: ''
}]

function RetailQtyExcelUpload() {
  ViewBase.call(this);

  const UPLOAD_FORM_ID = 'UploadExcelForm'

  let file = null;
  let resultTableData = [];
  let divisionList = []
  let selectedDivision = { code: null, name: null }

  const getDivisionList = () => {
    this.showLoading();
    PosmModel.getPosmMasterHierarchy({ fromLevel: 3, toLevel: 3 })
      .then((data) => {

        divisionList = data.map(({ id, name }) => { return { code: id, name } });
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const downloadRetailQtyExcelTemplate = () => {
    this.showLoading();
    getGoodsChannelTemplate(selectedDivision)
      .catch((error) => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const upload = (e, storageId) => {
    if (!this.validateForm(e, `#${UPLOAD_FORM_ID}`)) {
      return
    }

    this.showLoading();
    const formData = new FormData();
    formData.append('storageId', storageId);
    formData.append('inputFile', file);
    channelGoodsQtyCheck(formData)
      .then((result) => {
        resultTableData = result
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  return {
    oninit: () => {
      getDivisionList()
    },
    view: ({ attrs: { isOpen, onClose, warehouseStorage, handleConfirmClick } }) => {
      return m(Dialog, {
        isOpen,
        onClose,
        class: 'cui-dialog-xxl',
        title: this.getText('LT00001264', 'Retail Qty Excel Upload'),
        closeOnOutsideClick: false,
        content: [
          m('.card.mb-3',
            m('.card-body',
              m('.row',
                m('.col-4.align-self-center',
                  `${this.getText('LT00001269', 'Warehouse')}: ${warehouseStorage.warehouse.name}`
                ),
                m('.col-4.position-relative',
                  m('label.form-label[for="fromVendor"]',
                    this.getText('LT00000233', 'Division')
                  ),
                  m(SingleSelectComponent, {
                    allowEmpty: divisionList.length != 0,
                    items: divisionList,
                    selectedItem: selectedDivision,
                    onSelect: (selectedItem) => {
                      selectedDivision = selectedItem;
                    }
                  })
                ),
              ),
              m('form.position-relative.needs-validation[novalidate]', {
                id: UPLOAD_FORM_ID, onsubmit: (e) => {
                  upload(e, warehouseStorage.storageLocation.code)
                }
              },
                m('.row',
                  m('.col-8.position-relative',
                    m('label.form-label.mandatory', this.getText('LT00000792', 'File Upload')),
                    m(FileUploadInputComponent, {
                      accept: FILE_EXTENSIONS.XLSX,
                      required: true,
                      onInput: (data) => { file = data; },
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  ),
                  m('.col-4.align-self-end',
                    selectedDivision?.code && m('button.btn.btn-primary', {
                      type: 'button',
                      style: { 'white-space': 'nowrap' },
                      onclick: downloadRetailQtyExcelTemplate
                    },
                      m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText('LT00000218', 'Download Template')
                    ),
                  ),
                  m('.col-12.d-flex.justify-content-end',
                    m('button.btn.btn-primary', { type: 'submit', form: UPLOAD_FORM_ID }, this.getText("LT00000290", "Upload"))
                  )
                ),
              )
            )
          ),
          m('.card',
            m('.card-body',
              m('.row.gap-3',
                m('.col-12',
                  m('.table-responsive',
                    m('table.table.table-hover',
                      m('thead',
                        m('tr.align-middle',
                          m('th[scope="col"]', this.getText('LT00001272', 'Control No')),
                          m('th[scope="col"]', this.getText('LT00001268', 'Basic Model')),
                          m('th[scope="col"]', this.getText('LT00001244', 'Retail Code')),
                          m('th[scope="col"]', this.getText('LT00001245', 'Retail')),
                          m('th[scope="col"]', this.getText('LT00001244', 'Upload Qty')),
                          m('th[scope="col"]', this.getText('LT00001273', 'Total Qty')),
                          m('th[scope="col"]', this.getText('LT00001277', 'Storage Qty')),
                          m('th[scope="col"]', this.getText('LT00001260', 'Retail Qty')),
                          m('th[scope="col"]', this.getText('LT00000152', 'Remarks'))
                        )
                      ),
                      m('tbody',
                        (resultTableData.length == 0) &&
                        m('tr.align-middle',
                          m('td[colSpan=9]', this.getText("EM00000141", "No records found."))
                        ),
                        resultTableData.length > 0 &&
                        resultTableData.map((data, index) =>
                          m('tr.align-middle',
                            m('td', m('span.cursor-text', data.goodsControlId)),
                            m('td', m('span.cursor-text', data.goodsName)),
                            m('td', m('span.cursor-text', data.channelCode)),
                            m('td', m('span.cursor-text', data.channelName)),
                            m('td', m('span.cursor-text', data.uploadQty)),
                            m('td', m('span.cursor-text', data.totalQty)),
                            m('td', m('span.cursor-text', data.storageQty)),
                            m('td', m('span.cursor-text', data.stockQty)),
                            m('td', m('span.cursor-text', data.remarks))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          this.getBaseViews()
        ],
        footer: [
          m('.d-flex.justify-content-end.gap-2',
            m('button.btn.btn-primary', {
              disabled: resultTableData.length === 0 || resultTableData.some(({ remarks }) => remarks),
              onclick: () => {
                handleConfirmClick(resultTableData);
                onClose();
              },
            }, this.getText('LT00000043', 'Confirm')),
            m('button.btn.btn-white', {
              onclick: onClose,
            }, this.getText('LT00000021', 'Close')),
          )
        ]
      })
    }
  }
}
export default RetailQtyExcelUpload